import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative w-14 h-8 rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary-500"
      aria-label="Toggle theme"
    >
      <span className={`absolute top-1 left-1 w-6 h-6 rounded-full bg-white dark:bg-gray-900 flex items-center justify-center transition-transform duration-300 ${theme === 'dark' ? 'translate-x-6' : 'translate-x-0'}`}>
        {theme === 'light' ? <FiSun className="w-4 h-4 text-yellow-500" /> : <FiMoon className="w-4 h-4 text-blue-400" />}
      </span>
    </button>
  );
};

export default ThemeToggle;
